import { BaseComponentProps } from 'adminDashboard/benefitDetails/common/productClassWizardModal/Common'
import SetEligibleExpenses, {
  SetEligibleExpensesProps,
} from 'adminDashboard/benefitDetails/common/productClassWizardModal/components/setEligibleExpenses'

import { SetIchraRenewalReimbursementProductRequest, setIchraRenewalReimbursementProduct } from 'core'

import { useCommandRequestV2 } from 'common/hooks'

const SetIchraRenewalClassEligibleExpenses = (props: BaseComponentProps<SetEligibleExpensesProps>) => {
  const { sendCommand: sendSetProductClassAllowances } = useCommandRequestV2(
    (request: SetIchraRenewalReimbursementProductRequest) => setIchraRenewalReimbursementProduct(request),
  )

  const commandHandler = async (request: SetIchraRenewalReimbursementProductRequest) => {
    const result = await sendSetProductClassAllowances(request)
    return result
  }

  return <SetEligibleExpenses {...props} commandHandler={commandHandler} />
}

export default SetIchraRenewalClassEligibleExpenses
